// extracted by mini-css-extract-plugin
export default {"wrapper":"vE-z","viewport":"wE-z","container":"xE-z","slide":"yE-z"};